import firebase from 'firebase/app'
import { notification } from 'ant-design-vue'
// import 'firebase/auth'
// import 'firebase/database'
// import store from '../../store'
import config from '../../../environment.json'
const firebaseConfig = {
  apiKey: config[process.env.NODE_ENV].firebaseConfig.apiKey,
  authDomain: config[process.env.NODE_ENV].firebaseConfig.authDomain,
  databaseURL: config[process.env.NODE_ENV].firebaseConfig.databaseURL,
  projectId: config[process.env.NODE_ENV].firebaseConfig.projectId,
  storageBucket: config[process.env.NODE_ENV].firebaseConfig.storageBucket,
  messagingSenderId: config[process.env.NODE_ENV].firebaseConfig.messagingSenderId,
  appId: config[process.env.NODE_ENV].firebaseConfig.appId,
  measurementId: config[process.env.NODE_ENV].firebaseConfig.measurementId,
}

firebase.initializeApp(firebaseConfig)
export const firebaseAuth = firebase.auth()
export const firebaseDatabase = firebase.database()
// const messaging = firebase.messaging()
// const firestore = firebase.firestore()
/*
navigator.serviceWorker.register('firebase-messaging-sw.js',
  { scope: 'firebase-cloud-messaging-push-scope' })
  .then((registration) => {
    // console.log('registration')
    messaging.useServiceWorker(registration)
  })
  .catch(error => {
    console.log(error)
  })

const broadcast = new BroadcastChannel('count-channel')

// Listen to the response
broadcast.onmessage = (event) => {
  console.log('DATA')
  console.log(event.data.payload)
  store.commit('ADD_NOTIFICATION', {
    message: event.data.payload.data.title,
    description: event.data.payload.data.body,
  })
}
requestNotificationPermission()
export const firebaseAuth = firebase.auth()
export const firebaseDatabase = firebase.database()
function requestNotificationPermission() {
  messaging
    .requestPermission()
    .then(() => {
      return firebase
        .messaging()
        .getToken()
        .then((token) => {
          /* database.ref('/devices').push({
            token: token,
          })
          // console.log(token)
          // console.log(store.getters['user/user'].email)
          firestore.collection('adminDevices').doc(store.getters['user/user'].email).set({ token: token })
          // console.log(token)
        })
        .catch((error) => {
          console.log(error)
        })
    })
}
 */
export async function login(email, password) {
  return firebaseAuth
    .signInWithEmailAndPassword(email, password)
    .then(() => true)
    .catch(error => {
      notification.warning({
        message: error.code,
        description: error.message,
      })
    })
}

export async function register(email, password, name) {
  return firebaseAuth
    .createUserWithEmailAndPassword(email, password)
    .then(response => {
      if (response.user) {
        const { uid } = response.user
        firebaseDatabase
          .ref('users')
          .child(uid)
          .set({
            role: 'admin',
            name,
          })
      }
      return true
    })
    .catch(error => {
      console.log(error)
      notification.warning({
        message: error.code,
        description: error.message,
      })
    })
}

export async function currentAccount() {
  let userLoaded = false
  function getCurrentUser(auth) {
    return new Promise((resolve, reject) => {
      if (userLoaded) {
        resolve(firebaseAuth.currentUser)
      }
      const unsubscribe = auth.onAuthStateChanged(user => {
        userLoaded = true
        unsubscribe()
        const getUserData = async () => {
          if (user) {
            const userFields = await firebaseDatabase
              .ref('users')
              .child(user.uid)
              .once('value')
              .then(snapshot => {
                return snapshot.val()
              })
            const mergedUser = Object.assign(user, {
              id: user.uid,
              name: userFields.name,
              role: userFields.role,
              avatar: user.photoUrl,
            })
            return mergedUser
          }
          return user
        }
        resolve(getUserData())
      }, reject)
    })
  }
  return getCurrentUser(firebaseAuth)
}

export async function logout() {
  return firebaseAuth.signOut().then(() => true)
}
